export function handleCheckLoading(commonLoading, expectedType) {
  return commonLoading?.loading && commonLoading?.type === expectedType;
}

export function removeCountryCode(countryCode, phoneNumber) {
  if (countryCode && phoneNumber) {
    const codeDigits = countryCode.replace(/\D/g, "");
    const phoneDigits = phoneNumber.replace(/\D/g, "");

    const numberWithoutCode = phoneDigits.startsWith(codeDigits)
      ? phoneDigits.slice(codeDigits.length)
      : phoneDigits;

    return `${countryCode} ${numberWithoutCode}`;
  }

  return "-";
};

